import { render } from "./TextErrorMessage.vue?vue&type=template&id=6b1cf0ec&scoped=true"
import script from "./TextErrorMessage.vue?vue&type=script&lang=js"
export * from "./TextErrorMessage.vue?vue&type=script&lang=js"

import "./TextErrorMessage.vue?vue&type=style&index=0&id=6b1cf0ec&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1cf0ec"]])

export default __exports__